import { Anchor, Stack, Text, Tooltip } from '@mantine/core';
import { Dropzone } from '@mantine/dropzone';
import { notifications } from '@mantine/notifications';
import React from 'react';
import { DROPZONE_ACCEPT, SUPPORTED_FORMATS_LABEL } from '../allowedFileTypes';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type DocumentsDropZoneProps = {
  onFilesSelected: (files: File[]) => void;
  onSharePointClick: (e: React.MouseEvent<HTMLElement>) => void;
};

export default function DocumentsDropZone({
  onFilesSelected,
  onSharePointClick,
}: DocumentsDropZoneProps) {
  return (
    <Dropzone
      onDrop={onFilesSelected}
      onReject={fileRejections => {
        fileRejections.forEach(fileRejection => {
          notifications.show({
            title: `Failed to upload ${fileRejection.file.name}`,
            message: `This file type is not supported. Supported formats: ${SUPPORTED_FORMATS_LABEL}.`,
            color: 'red',
          });
        });
      }}
      maxSize={2147483648} // 2GB
      p="md"
      styles={{
        root: {
          border: '1px dashed var(--mantine-color-gray-2)',
          borderRadius: 20,
          backgroundColor: 'transparent',
        },
      }}
      accept={DROPZONE_ACCEPT}
      data-testid="documents-drop-zone"
    >
      <Stack gap="xs" align="flex-start">
        <Text size="md" fw={FONT_WEIGHTS.medium} c="gray.10" lh="24px" maw={486}>
          Add from{' '}
          <Anchor
            component="button"
            size="md"
            fw={FONT_WEIGHTS.medium}
            c="brand.7"
            underline="always"
            onClick={onSharePointClick}
            data-testid="drop-zone-share-point"
          >
            SharePoint/OneDrive
          </Anchor>{' '}
          or from your{' '}
          <Anchor
            component="button"
            size="md"
            fw={FONT_WEIGHTS.medium}
            c="brand.7"
            underline="always"
            data-testid="drop-zone-computer"
          >
            computer
          </Anchor>
        </Text>
        <Tooltip label={SUPPORTED_FORMATS_LABEL} position="top" withArrow>
          <Text
            size="xs"
            lh="18px"
            fw={FONT_WEIGHTS.medium}
            c="gray.6"
            w="fit-content"
            style={{ textDecorationLine: 'underline', textDecorationStyle: 'dotted' }}
          >
            Supported formats
          </Text>
        </Tooltip>
      </Stack>
    </Dropzone>
  );
}
